export { default } from './Yotpo';
